import { render, staticRenderFns } from "./datatables_batch_template.vue?vue&type=template&id=0def14d4&"
import script from "./datatables_batch_template.vue?vue&type=script&lang=js&"
export * from "./datatables_batch_template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports